// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --collapse-button-size: 32px;
  --tree-space-y: 12px;
  display: block;
  width: 100%;
}
:host.collapsible {
  --connector-width: 23px;
}

.menu-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.collapse-button {
  width: var(--collapse-button-size, 48px);
  height: var(--collapse-button-size, 48px);
  padding: calc((var(--collapse-button-size, 48px) - var(--collapse-icon-size, 24px)) / 2);
  transition: cubic-bezier(0.4, 0, 0.2, 1) 225ms transform;
}
.collapse-button mat-icon {
  width: var(--collapse-icon-size, 24px);
  height: var(--collapse-icon-size, 24px);
  line-height: var(--collapse-icon-size, 24px);
  font-size: var(--collapse-icon-size, 24px);
}
.collapse-button ::ng-deep .mat-mdc-button-touch-target {
  width: var(--collapse-button-size, 48px);
  height: var(--collapse-button-size, 48px);
}
.collapse-button.collapsed {
  transform: rotate(180deg);
}

.tree-container {
  width: 100%;
  overflow: hidden;
  transition: cubic-bezier(0.4, 0, 0.2, 1) 225ms max-height;
}
.tree-container.collapsed {
  max-height: 0 !important;
}

.tree {
  margin: 4px 0 2px;
  padding-left: 2.5rem;
}

.empty-warning {
  flex-grow: 1;
  color: rgb(141, 37, 46);
  text-align: center;
}

.transition {
  transition: all 0.1s ease-in-out;
}

.row {
  padding: 6px 8px;
  margin-top: var(--tree-space-y, 6px);
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  -moz-column-gap: 10px;
       column-gap: 10px;
}

.connector {
  position: relative;
}
.connector::before {
  border-width: 0 0 var(--connector-size, 2px) var(--connector-size, 2px);
  top: calc(0px - var(--tree-space-y, 6px) - 1px);
  height: calc(50% + var(--tree-space-y, 6px) - var(--connector-size, 2px) / 2 + 1px);
}
.connector::after {
  border-width: 0 0 0 var(--connector-size, 2px);
  top: calc(50% + var(--connector-size, 2px) / 2);
  height: calc(50% - var(--connector-size, 2px) / 2 + 1px);
  border-radius: 0 !important;
}
.connector::before, .connector::after {
  content: "";
  left: calc(0px - var(--connector-size, 2px) - var(--connector-width, 11px) - 1px);
  border-style: solid;
  width: var(--connector-width, 10px);
  position: absolute;
}
.connector:last-child::after {
  content: none;
}

.input-field {
  --input-height: 32px;
  --input-line-height: 16px;
  --input-y-padding: calc((var(--input-height, 56px) - var(--input-line-height, 24px)) / 2);
}
.input-field.operator ::ng-deep .mat-mdc-form-field-infix {
  width: 3.5rem !important;
}
.input-field ::ng-deep .mat-mdc-form-field-infix {
  padding-top: var(--input-y-padding, 16px);
  padding-bottom: var(--input-y-padding, 16px);
  min-height: var(--input-height, 56px);
}
.input-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

::ng-deep .mat-mdc-select-panel {
  overflow-y: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/query-builder/query-builder.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,oBAAA;EAMA,cAAA;EACA,WAAA;AAJF;AADE;EACE,uBAAA;AAGJ;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AADF;;AAIA;EACE,wCAAA;EACA,yCAAA;EACA,wFAAA;EACA,wDAAA;AADF;AAGE;EACE,sCAAA;EACA,uCAAA;EACA,4CAAA;EACA,0CAAA;AADJ;AAIE;EACE,wCAAA;EACA,yCAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,gBAAA;EACA,yDAAA;AAJF;AAME;EACE,wBAAA;AAJJ;;AAQA;EACE,iBAAA;EACA,oBAAA;AALF;;AAQA;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;OAAA,gBAAA;AALF;;AAQA;EACE,kBAAA;AALF;AAOE;EACE,uEAAA;EACA,+CAAA;EACA,mFAAA;AALJ;AAQE;EACE,8CAAA;EACA,+CAAA;EACA,wDAAA;EACA,2BAAA;AANJ;AASE;EAEE,WAAA;EACA,iFAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;AARJ;AAWE;EACE,aAAA;AATJ;;AAaA;EACE,oBAAA;EACA,yBAAA;EACA,yFAAA;AAVF;AAaI;EACE,wBAAA;AAXN;AAeE;EACE,yCAAA;EACA,4CAAA;EACA,qCAAA;AAbJ;AAgBE;EACE,aAAA;AAdJ;;AAkBA;EACE,2BAAA;AAfF","sourcesContent":[":host {\n  --collapse-button-size: 32px;\n  --tree-space-y: 12px;\n\n  &.collapsible {\n    --connector-width: 23px;\n  }\n\n  display: block;\n  width: 100%;\n}\n\n.menu-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.button-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.collapse-button {\n  width: var(--collapse-button-size, 48px);\n  height: var(--collapse-button-size, 48px);\n  padding: calc((var(--collapse-button-size, 48px) - var(--collapse-icon-size, 24px)) / 2);\n  transition: cubic-bezier(0.4, 0, 0.2, 1) 225ms transform;\n\n  mat-icon {\n    width: var(--collapse-icon-size, 24px);\n    height: var(--collapse-icon-size, 24px);\n    line-height: var(--collapse-icon-size, 24px);\n    font-size: var(--collapse-icon-size, 24px);\n  }\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: var(--collapse-button-size, 48px);\n    height: var(--collapse-button-size, 48px);\n  }\n\n  &.collapsed {\n    transform: rotate(180deg);\n  }\n}\n\n.tree-container {\n  width: 100%;\n  overflow: hidden;\n  transition: cubic-bezier(0.4, 0, 0.2, 1) 225ms max-height;\n\n  &.collapsed {\n    max-height: 0 !important;\n  }\n}\n\n.tree {\n  margin: 4px 0 2px;\n  padding-left: 2.5rem;\n}\n\n.empty-warning {\n  flex-grow: 1;\n  color: rgb(141, 37, 46);\n  text-align: center;\n}\n\n.transition {\n  transition: all 0.1s ease-in-out;\n}\n\n.row {\n  padding: 6px 8px;\n  margin-top: var(--tree-space-y, 6px);\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  column-gap: 10px;\n}\n\n.connector {\n  position: relative;\n\n  &::before {\n    border-width: 0 0 var(--connector-size, 2px) var(--connector-size, 2px);\n    top: calc(0px - var(--tree-space-y, 6px) - 1px);\n    height: calc(50% + var(--tree-space-y, 6px) - var(--connector-size, 2px) / 2 + 1px);\n  }\n\n  &::after {\n    border-width: 0 0 0 var(--connector-size, 2px);\n    top: calc(50% + var(--connector-size, 2px) / 2);\n    height: calc(50% - var(--connector-size, 2px) / 2 + 1px);\n    border-radius: 0 !important;\n  }\n\n  &::before,\n  &::after {\n    content: '';\n    left: calc(0px - var(--connector-size, 2px) - var(--connector-width, 11px) - 1px);\n    border-style: solid;\n    width: var(--connector-width, 10px);\n    position: absolute;\n  }\n\n  &:last-child::after {\n    content: none;\n  }\n}\n\n.input-field {\n  --input-height: 32px;\n  --input-line-height: 16px;\n  --input-y-padding: calc((var(--input-height, 56px) - var(--input-line-height, 24px)) / 2);\n\n  &.operator {\n    ::ng-deep .mat-mdc-form-field-infix {\n      width: 3.5rem !important;\n    }\n  }\n\n  ::ng-deep .mat-mdc-form-field-infix {\n    padding-top: var(--input-y-padding, 16px);\n    padding-bottom: var(--input-y-padding, 16px);\n    min-height: var(--input-height, 56px);\n  }\n\n  ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n  }\n}\n\n::ng-deep .mat-mdc-select-panel {\n  overflow-y: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
